"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = (0, tslib_1.__importStar)(require("react"));
var LivePointIcon = function (_a) {
    var size = _a.size, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (React.createElement("svg", (0, tslib_1.__assign)({ viewBox: "0 0 14 14", fill: "currentColor", width: size || '14', height: size || '14' }, props),
        React.createElement("defs", null,
            React.createElement("rect", { id: "path-1", x: "0", y: "0", width: "12", height: "12", rx: "6" })),
        React.createElement("g", { id: "Page-1", stroke: "none", fill: "none", strokeWidth: "1", fillRule: "evenodd" },
            React.createElement("g", { id: "02---Thumbnail-Components", transform: "translate(-1376 -7463)" },
                React.createElement("g", { id: "Group-27", transform: "translate(1377 7464)" },
                    React.createElement("g", { id: "Rectangle-9", opacity: ".4" },
                        React.createElement("use", { fill: "currentColor", xlinkHref: "#path-1" }),
                        React.createElement("rect", { stroke: "currentColor", x: "-.45", y: "-.45", width: "12.9", height: "12.9", rx: "6.45", strokeWidth: ".9" })),
                    React.createElement("rect", { id: "Rectangle-9", fill: "currentColor", x: "3", y: "3", width: "6", height: "6", rx: "3" }))))));
};
LivePointIcon.displayName = 'LivePointIcon';
exports.default = LivePointIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=LivePointIcon.js.map